import React from 'react';
import { Eye, Download, Printer, Mail } from 'lucide-react';

const BulletinActions = ({ 
  bulletinId, 
  onVoir, 
  onDownload, 
  onPrint, 
  onEmail 
}) => {
  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => onVoir(bulletinId)}
        className="text-[#202654] hover:text-[#202654]/80 transition-colors"
        title="Voir le bulletin"
      >
        <Eye className="h-4 w-4" />
      </button>
      
      <button
        onClick={() => onDownload(bulletinId)}
        className="text-gray-600 hover:text-gray-800 transition-colors"
        title="Télécharger"
      >
        <Download className="h-4 w-4" />
      </button>
      
      <button
        onClick={() => onPrint(bulletinId)}
        className="text-gray-600 hover:text-gray-800 transition-colors"
        title="Imprimer"
      >
        <Printer className="h-4 w-4" />
      </button>
      
      <button
        onClick={() => onEmail(bulletinId)}
        className="text-gray-600 hover:text-gray-800 transition-colors"
        title="Envoyer par email"
      >
        <Mail className="h-4 w-4" />
      </button>
    </div>
  );
};

export default BulletinActions;